import { getHeaders } from "CommonUtils";
import axios from "axios";
import { SubmissionError } from "redux-form";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { INSTANCE_URL, itemCount } from "Constants";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export var TEMPLATES_CONTENT = "TEMPLATES_CONTENT";
export var GET_EVENTCODE = "GET_EVENTCODE";
export var EVENT_SELECTED_TEMPLATE = "EVENT_SELECTED_TEMPLATE";
export var WEBSITE_CONTACT_RESPONSES = "WEBSITE_CONTACT_RESPONSES";
export var TEMPLATES_WIZARD_STEP = "TEMPLATES_WIZARD_STEP";
export var SAVE_TEMPLATES_WIZARD_DATA = "SAVE_TEMPLATES_WIZARD_DATA";
export var SHOW_CONNECT_DOMAIN_MODAL = "SHOW_CONNECT_DOMAIN_MODAL";
export var SAVE_CONNECT_DOMAIN_DATA = "SAVE_CONNECT_DOMAIN_DATA";
export var SAVE_OPTION_STATE_INSTALLURL = "SAVE_OPTION_STATE_INSTALLURL";
export var SAVE_TEMPLATE_THEME_DATA = "SAVE_TEMPLATE_THEME_DATA";
export var SAVE_OPTION_STATE_PUBLISH = "SAVE_OPTION_STATE_PUBLISH";
export var SHOW_CONFIRM_MODAL = "SHOW_CONFIRM_MODAL";
export var SAVE_SELECTED_PLAN = "SAVE_SELECTED_PLAN";
export var SAVE_OPTION_STATE_THEME = "SAVE_OPTION_STATE_THEME";
export var DEPLOY_RESPONSE = "DEPLOY_RESPONSE";
export var WEBSITE_MODULE_CONTENT = "WEBSITE_MODULE_CONTENT";
export var SITE_DETAILS = "SITE_DETAILS";
export var SAVE_OPTION_STATE_DOMAINS = "SAVE_OPTION_STATE_DOMAINS";
export var SAVE_OPTION_STATE_UPGRADE = "SAVE_OPTION_STATE_UPGRADE";
export var TEMPLATE_MODULEPATH = "TEMPLATE_MODULEPATH";
export var REDEPLOY = "REDEPLOY";
export var INITIAL_CHECK_AT_THEME = "INITIAL_CHECK_AT_THEME";
export var TEMPLATE_IMAGEPATH = "TEMPLATE_IMAGEPATH";
export var WEBSITE_PAGES = "WEBSITE_PAGES";
export var EVENT_WEBSITE_PAGES_VALUES = "EVENT_WEBSITE_PAGES_VALUES";
export var WEBSITE_HEADERFOOTER = "WEBSITE_HEADERFOOTER";
// export var WEBSITE_PAGES = 'WEBSITE_TITLE_SAVE';

var SPECIAL_ACCESS_KEY =
  "2b90fffc0bc8c99f88e9a492640556e747c69c65f6ff82cde87a2f9f388d069b";

export function knowEventcode(session) {
  // debugger;
  var url = `${INSTANCE_URL}/api/v2/eventifyscript_support?type=geteventcode&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: GET_EVENTCODE, payload: data });
      },
      (error) => {}
    );
  };
}

export function fetchTemplates(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/templates?related=event_template_by_templateid`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: TEMPLATES_CONTENT, payload: data });
      },
      (error) => {}
    );
  };
}

export function fetchWebTemplates(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/web_templates?related=event_template_by_templateid`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: TEMPLATES_CONTENT, payload: data });
      },
      (error) => {}
    );
  };
}

export function checkEventTemplate(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template?related=*&filter=(eventid=${session.eventid})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: EVENT_SELECTED_TEMPLATE, payload: data });
      },
      (error) => {}
    );
  };
}

export function updateSelectedTheme(
  session,
  templateid,
  selectedTemId,
  callback
) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template/${selectedTemId}`;
  var values = { templateid, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        dispatch(checkEventTemplate(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addSelectedTemplate(session, selectedTemId, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template`;
  let eventid = session.eventid;
  var values = { eventid, templateid: selectedTemId };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        dispatch(checkEventTemplate(session));
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateWebsitDetails(session, values, selectedTemId, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template/${selectedTemId}`;
  var body = { ...values, eventid: session.eventid };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function addTemplate(session, values, templateObj, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template`;
  let eventid = session.eventid;
  let templateid = templateObj.id;
  values = { ...values, eventid, templateid };
  let body = { resource: values };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
        //dispatch(fetchTemplates(session));
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function createDomain(subdomain, callback) {
  //This is an external api call through DF with specific key access
  let url = `${INSTANCE_URL}/api/v2/createTemplateDomain?api_key=${SPECIAL_ACCESS_KEY}&subdomain=${subdomain}`;

  var response = axios.get(url);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function deployTemplate(modulename, subdomain, callback) {
  //This is not a DF api call, so no Header required
  let url = `${INSTANCE_URL}/api/v2/websiteinfo?api_key=${SPECIAL_ACCESS_KEY}&modulename=${modulename}&subdomain=${subdomain}&type=deploy`;
  //debugger;
  var response = axios.get(url);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1 });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function validateDomain(subdomain, callback) {
  //This is not a DF api call, so no Header required
  let url = `${INSTANCE_URL}/api/v2/websiteinfo?api_key=${SPECIAL_ACCESS_KEY}&code=${subdomain}&type=validate`;

  var response = axios.get(url);
  return (dispatch) => {
    response
      .then(({ data }) => {
        callback({ success: 1, data });
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function updateWebsiteLiveStatus(session, value, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template `;
  var body = {
    resource: { id: id, isenabled: value, eventid: session.eventid },
  };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateFormid(session, value, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template `;
  var body = {
    resource: { id: id, eventformid: value, eventid: session.eventid },
  };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function fetchWebsiteResponse(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `limit=${itemCount}&offset=${offset}&`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_template_responses?filter=(eventid=${session.eventid})&${offSetQuery}include_count=true&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: WEBSITE_CONTACT_RESPONSES,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1 });
      },
      (error) => {}
    );
  };
}

export function fetchTemplatesWizardStep(step) {
  return { type: TEMPLATES_WIZARD_STEP, payload: step };
}

export function saveTemplatesWizardData(obj) {
  return { type: SAVE_TEMPLATES_WIZARD_DATA, payload: obj };
}
// ======== Alternative version of the same function ========
// export function saveTemplatesWizardData(obj, callback) {
//   return (dispatch) => {
//     dispatch({ type: SAVE_TEMPLATES_WIZARD_DATA, payload: obj});
//     callback({success:1})
//   };
// }

export function showConnectDomainModal(obj) {
  return { type: SHOW_CONNECT_DOMAIN_MODAL, payload: obj };
}

export function saveConnectDomainData(obj) {
  return { type: SAVE_CONNECT_DOMAIN_DATA, payload: obj };
}

export function saveOptionStateInstallURL(obj) {
  return { type: SAVE_OPTION_STATE_INSTALLURL, payload: obj };
}

export function saveTemplateThemeData(obj) {
  return { type: SAVE_TEMPLATE_THEME_DATA, payload: obj };
}

export function saveOptionStatePublish(obj) {
  return { type: SAVE_OPTION_STATE_PUBLISH, payload: obj };
}

export function showConfirmModal(obj) {
  return { type: SHOW_CONFIRM_MODAL, payload: obj };
}

export function saveSelectedPlan(obj) {
  return { type: SAVE_SELECTED_PLAN, payload: obj };
}

export function saveOptionStateTheme(obj) {
  return { type: SAVE_OPTION_STATE_THEME, payload: obj };
}

export function addWebsiteModuleData(session, resource, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/website_module`;
  let body = { resource: resource };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, result: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deployWebsite(session, params, callback) {
  let url =
    "https://eventify.io/templates/upload.php?eventcode=" +
    params.eventcode +
    "&template=" +
    params.template +
    "&subdomain=" +
    params.subdomain +
    ".eventify.io";
  let body = {};

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, result: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };

  // return (dispatch)=>{
  //   getRequest(url, session, dispatch, (data) => {

  //     dispatch({type: DEPLOY_RESPONSE, payload: data});
  //   }, (error) => {

  //   });
  // };
}

export function fetchWebsiteModule(session) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/website_module?related=*&include_count=true`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: WEBSITE_MODULE_CONTENT, payload: data });
      },
      (error) => {}
    );
  };
}

export function fetchSiteDetails(session) {
  var filter = encodeURI(`(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/website_module?related=*&include_count=true&filter=(${filter})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: SITE_DETAILS, payload: data });
      },
      (error) => {}
    );
  };
}

export function makeFresh(session, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/website_module?${filter}`;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (response) => {
        var returnData = { success: 1, result: response };
        callback(returnData);
      },
      (error) => {
        var returnData = { success: 0, message: error };
        callback(returnData);
      }
    );
  };
}

export function saveOptionStateDomains(obj) {
  return { type: SAVE_OPTION_STATE_DOMAINS, payload: obj };
}

export function updateDomain(session, resource, callback) {
  var filter = encodeURI(`filter=(eventid=${session.eventid})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/website_module?${filter}`;
  var body = { resource: resource };

  return (dispatch) => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, result: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function saveOptionStateUpgrade(obj) {
  return { type: SAVE_OPTION_STATE_UPGRADE, payload: obj };
}

export function fetchTemplateModulepath(session, id, callback) {
  var filter = encodeURI(`(id=${id})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/web_templates?related=*&include_count=true&filter=(${filter})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: TEMPLATE_MODULEPATH, payload: data });
      },
      (error) => {}
    );
  };
}

export function redeployFunction(obj) {
  return { type: REDEPLOY, payload: obj };
}

export function resetSiteDetails() {
  return { type: SITE_DETAILS, payload: {} };
}

export function initialCheckAtThemeFunc(value) {
  return { type: INITIAL_CHECK_AT_THEME, payload: value };
}

export function fetchPreviewImgPath(session, template, callback) {
  var filter = encodeURI(`(id=${template.id})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/web_templates?related=*&include_count=true&filter=(${filter})`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: TEMPLATE_IMAGEPATH, payload: data });
        callback({ success: 1, result: data });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function resetTemplateImageath() {
  return { type: TEMPLATE_IMAGEPATH, payload: {} };
}

export function fetchPages(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var filter = encodeURI(`(eventid=${session.eventid})`);
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_website_pages?include_count=true&filter=(${filter})&order=createdon%20DESC&${offSetQuery}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: WEBSITE_PAGES,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1, data: data });
      },
      (error) => {}
    );
  };
}

export function searchPages(session, search = "", pageCount = 0) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;
  var offSetQuery = `&limit=${perPage}&offset=${offset}`;
  var searchQuery = `(pagetitle like %${search}%)`;
  var filter = encodeURI(`(${searchQuery}) AND (eventid=${session.eventid})`);
  // var url = `${INSTANCE_URL}/api/v2/eventify/_table/exhibitors?related=appuser_by_exhibitoridfk&include_count=true&filter=(${filter})&order=createdon%20DESC${offSetQuery}`;
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_website_pages?include_count=true&filter=(${filter})&order=createdon%20DESC&${offSetQuery}`;

  var response = axios.get(url, getHeaders(session));

  return (dispatch) => {
    dispatch(showLoading());
    response
      .then(({ data }) => {
        dispatch({
          type: WEBSITE_PAGES,
          payload: { data: data.resource, count: data.meta.count },
        });
        dispatch(hideLoading());
      })
      .catch((error) => {
        dispatch(hideLoading());
      });
  };
}

export function fetchHeaderFooter(session, pageCount = 0, callback) {
  var perPage = itemCount;
  var offset = pageCount <= 1 ? 0 : (pageCount - 1) * perPage;

  var filter = encodeURI(`(eventid=${session.eventid})`);
  var offSetQuery = `limit=${itemCount}&offset=${offset}`;

  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_website?include_count=true&filter=(${filter})&order=createdon%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({
          type: WEBSITE_HEADERFOOTER,
          payload: { resource: data.resource, count: data.meta.count },
        });
        callback({ success: 1, data: data });
      },
      (error) => {}
    );
  };
}

export function saveTitleandurl(session, values, callback) {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event_website_pages`;
  let body = { resource: { ...values, eventid: session.eventid } };

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        callback({ success: 1, result: response });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function deleteSavedItems(session, id, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/event_website_pages/${id}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0, result: data });
        dispatch(fetchPages(session));
      },
      (error) => {
        callback({ error: 1, message: error });
      }
    );
  };
}
